<div #mapViewNode [style.height]='bodyHeightAsString$|async'>
</div>

<app-historique-form cdkDrag
                     [loading]='selectionLoading'
                     [exportLoading]='exportLoading'
                     [whereClauseFields]='configService.Config.history'
                     (applyFilter)='filter($event)'
                     (applyExport)='export($event)'
></app-historique-form>
